import type { ImprovementAreaResponse } from 'api/__GENERATED';

// Maps a single ImprovementArea DTO onto the normalized `Data.ImprovementArea`
// shape. The wire DTO carries branchId/distributionCenterId plus audit fields
// (createdBy/updatedAt/...); the UI ignores all of them — areas are
// intentionally free-floating per product decision.
function toImprovementArea(dto: ImprovementAreaResponse): Data.ImprovementArea {
  const { id, name, description, sortOrder, isActive } = dto;

  const improvementArea: Data.ImprovementArea = {
    id,
    name,
    description: description ?? null,
    sortOrder,
    isActive,
  };

  return improvementArea;
}

export { toImprovementArea };
